<script>
    import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

    export default {
        name: 'design-2021-organization-school-index-component',
        components: { Design2021ApprenticeDataTable },
        props: {
            schoolsIn: {
                type: Array,
                required: true
            },
            lessonModulesIn: {
                type: Array,
                required: true
            },
            lessonModuleTypesIn: {
                type: Array,
                required: false,
            }
        },
        data() {
            return {
                schools: this.schoolsIn,
                addSchool: null,
                editSchool: null,
                fields: [
                    {
                        key: 'name',
                        label: this.$t('common.name'),
                        sortable: true
                    },
                    {
                        key: 'lesson_modules',
                        label: this.$t('lesson_module.lesson_modules')
                    },
                    {
                        key: 'actions',
                        label: this.$t('common.actions')
                    }
                ]
            };
        },
        methods: {
            openAddSchool() {
                this.addSchool = true;
                this.$refs['add-school'].show();
            },
            openEditSchool(school) {
                this.editSchool = true;
                this.$refs['edit-school'].show(school);
            },
            addSchoolToSchools(school) {
                this.schools.push(school);
            },
            updateSchool(school) {
                if (!school.lesson_modules.length) {
                    this.schools = this.schools.filter((school0) => school0.id !== school.id);
                }
                this.schools = this.schools.map((school0) => {
                    if (school.id === school0.id) {
                        return school;
                    }
                    return school0;
                });
            },
            updateSchoolsLessonModule(updatedSchool) {
                this.schools = this.schools.map(school =>  {
                    if(school.id === updatedSchool.id){
                        school.lesson_modules = [...updatedSchool.lesson_modules];
                    }
                    return school;
                }).filter(school => school.lesson_modules.length > 0);
            }
        }
    };
</script>

<template>
    <div class="apprentice-simple-card">
        <design2021-apprentice-data-table
            v-if="!addSchool && !editSchool"
            :fields="fields"
            :show-empty="true"
            :items="schools">
            <template v-slot:options>
                <div class="actions">
                    <b-button
                        class="btn-add btn-add-school"
                        variant="primary"
                        @click="openAddSchool">
                        {{ $t('school.add_school') }}
                    </b-button>
                </div>
            </template>
            <template v-slot:cell(lesson_modules)="data">
                <div class="lesson-modules">
                    <span v-for="lessonModule in data.item.lesson_modules"
                    :key="lessonModule.id">
                        {{lessonModule.name}}
                    </span>
                </div>
<!--                {{ data.item.lesson_modules.map((lm) => lm.name).toString() }}-->
            </template>
            <template v-slot:cell(actions)="data">

                <div class="actions">
                    <b-button
                        class="btn-edit"
                        variant="primary-icon-only"
                        @click="openEditSchool(data.item)">
                    </b-button>
                </div>
            </template>
            <template #empty="scope">
                <div class="not-found with-header attachments-list">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('organization.school.no_lesson_modules_found') }}</div>
                </div>
            </template>

        </design2021-apprentice-data-table>
        <design-2021-organization-add-school-component
            ref="add-school"
            @school-added="addSchoolToSchools"
            @back="addSchool = null"
            :types-in="lessonModuleTypesIn"
            :lessonModulesIn="lessonModulesIn">
        </design-2021-organization-add-school-component>
        <design-2021-organization-edit-school-component
            ref="edit-school"
            @school-updated="updateSchool"
            @school-synced="updateSchoolsLessonModule"
            @back="editSchool = null"
            :types-in="lessonModuleTypesIn"
            :lessonModulesIn="lessonModulesIn">
        </design-2021-organization-edit-school-component>
    </div>
</template>

<style scoped lang="scss">
.lesson-modules {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');

    span {
        font-size: 0.75rem;

        &:not(:last-child):after{
            content: ',';
            position: relative;
        }
    }
}
</style>